import React from 'react';
import GitHubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import './styles.css';

const Zoom = require('react-reveal/Zoom');

export default function FloatSocialMedias(){
    return (
        <div className="float-social-medias">
            <Zoom>
                <a href="https://github.com/Brian-Mello" target="blank"><GitHubIcon className="github-icon"/></a>
                <a href="https://twitter.com/Mello_Brian" target="blank"><TwitterIcon className="twitter-icon"/></a>
                <a href="https://www.instagram.com/brian_mello_" target="blank"><InstagramIcon className="instagram-icon"/></a>                   
                <a href="https://www.linkedin.com/in/brian-de-paula-mello-6b8577161/" target="blank"><LinkedInIcon className="linkedin-icon"/></a>
                <a href="https://wa.me/5521982681935" target="blank"><WhatsAppIcon className="whatsapp-icon"/></a>                    
            </Zoom>                          
        </div>
    )
}